import React from "react";

export default function FootIcon({
  size = 20,
  className,
  ...rest
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99948 5.42994L2.84953 7.2252C2.57278 7.32169 2.26755 7.17403 2.17116 6.89675L1.77952 5.77106C1.68313 5.49402 1.83064 5.18848 2.10763 5.09199L7.31648 3.27602C7.56086 3.19098 7.83031 3.32134 7.91526 3.56597L8.32758 4.75063C8.42397 5.02791 8.27623 5.33345 7.99948 5.42994Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.30122 9.9812C7.80614 9.63253 7.68614 8.94176 8.03445 8.44641L9.17018 6.83072C8.91412 6.48741 8.46406 6.33756 8.0476 6.47644L3.52101 7.98687C3.11014 8.12405 2.8329 8.50878 2.8329 8.94249V15.7429C2.8329 16.299 3.28344 16.75 3.83914 16.75H4.24075L8.76783 10.3099L8.30122 9.9812Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2337 13.9472L18.0019 12.6709C17.9265 12.2565 17.6013 11.9327 17.1868 11.8593L15.3834 11.5409L14.4044 12.9334C14.0561 13.4287 13.3663 13.5488 12.8712 13.2002L12.4046 12.8717L9.67848 16.75H12.261C13.154 16.75 14.0383 16.5712 14.8615 16.2242L17.6342 15.0556C18.0689 14.8724 18.3181 14.4116 18.2337 13.9472Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7964 9.90372L10.8393 7.11653C10.5996 6.94768 10.2656 7.00591 10.097 7.24567L9.93972 7.46934L9.06444 8.67471C8.89576 8.91471 8.95394 9.24925 9.19369 9.41811L13.0994 12.1692C13.3391 12.3381 13.6733 12.2799 13.842 12.0401L14.5693 11.0448L14.9103 10.5596C15.0592 10.3479 15.0079 10.0528 14.7964 9.90372Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.44863 10.7894L5.25697 16.75H8.66779L11.7296 12.3961L9.44863 10.7894Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export const FootWideIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8665 14.2717L11.384 16.5222C11.0357 16.6432 10.6515 16.4581 10.5301 16.1105L10.0372 14.6994C9.91583 14.3521 10.1015 13.9691 10.4502 13.8481L17.0068 11.5717C17.3144 11.4651 17.6535 11.6285 17.7605 11.9351L18.2795 13.4202C18.4008 13.7678 18.2148 14.1508 17.8665 14.2717ZM18.2463 19.977C17.6231 19.54 17.4721 18.674 17.9105 18.0531L19.3401 16.0277C19.0178 15.5974 18.4513 15.4095 17.927 15.5836L12.2292 17.477C11.7121 17.649 11.3631 18.1313 11.3631 18.6749V27.1997C11.3631 27.8967 11.9302 28.4621 12.6297 28.4621H13.1352L18.8336 20.3891L18.2463 19.977ZM30.457 23.3488L30.7487 24.9487C30.855 25.5308 30.5412 26.1084 29.994 26.3381L26.504 27.803C25.4678 28.2379 24.3547 28.4621 23.2306 28.4621H19.9799L23.4114 23.6005L23.9987 24.0122C24.6219 24.4493 25.4902 24.2987 25.9286 23.6778L27.1609 21.9322L29.4309 22.3314C29.9527 22.4233 30.362 22.8292 30.457 23.3488ZM26.422 19.8799L26.1882 19.7159L25.4367 19.1887L21.4411 16.386C21.1393 16.1743 20.719 16.2473 20.5067 16.5479L20.3087 16.8283L19.207 18.3393C18.9947 18.6401 19.0679 19.0595 19.3697 19.2712L19.5388 19.3897L20.2904 19.9172L23.3652 22.0739L24.1168 22.6011L24.2859 22.7199C24.5877 22.9315 25.0084 22.8585 25.2207 22.558L26.1361 21.3103L26.5654 20.7021C26.7529 20.4367 26.6883 20.0668 26.422 19.8799ZM14.4144 28.4621L19.6906 20.9902L22.5617 23.0042L18.7077 28.4621H14.4144Z"
          fill="#222222"
        />
      </g>
    </svg>
  );
};
